import { supabase } from '../../supabaseClient'; 

// Delete entity function
export async function deleteEntity(entityId) {
  if (!entityId) {
    throw new Error('Entity ID is required for deletion');
  }

  try {
    // Delete the record from the 'entities' table where the entity_id matches
    const { data, error } = await supabase
      .from('entities')
      .delete()
      .eq('entity_id', entityId);

    if (error) {
      console.error('Error deleting data:', error.message);
      throw new Error(`Error deleting data: ${error.message}`);
    }

    if (data.length === 0) {
      console.log('No entity found with the provided entityId');
      return null;  // No data found to delete
    }

    console.log('Entity deleted successfully:', data);
    return data;  // Return the deleted entity data
  } catch (error) {
    console.error('Unexpected error:', error);
    throw new Error(`Unexpected error: ${error.message}`);
  }
}
